import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{
      position: 'fixed',        // ✅ Fixed positioning
      top: 0,
      left: 0,
      width: '100vw',           // ✅ Full viewport width
      height: '100vh',          // ✅ Full viewport height
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      fontFamily: 'Arial, sans-serif',
      zIndex: 9999              // ✅ Ensure it's on top
    }}>
      {/* Your 404 content */}
      <h1 style={{
        fontSize: '10rem',
        margin: '0 0 1rem 0',
        fontWeight: 'bold',
        textShadow: '0 4px 8px rgba(0,0,0,0.3)'
      }}>
        404
      </h1>
      
      <h2 style={{
        fontSize: '3rem',
        margin: '0 0 2rem 0',
        fontWeight: '300'
      }}>
        Page Not Found
      </h2>
      
      <p style={{
        fontSize: '1.3rem',
        marginBottom: '3rem',
        textAlign: 'center',
        maxWidth: '600px',
        opacity: 0.9
      }}>
        The page you're looking for doesn't exist.
      </p>
      
      <div style={{ display: 'flex', gap: '2rem' }}>
        <button
          onClick={() => navigate('/dashboard')}
          style={{
            padding: '15px 30px',
            backgroundColor: 'rgba(255, 255, 255, 0.2)',
            color: 'white',
            border: '2px solid white',
            borderRadius: '50px',
            fontSize: '1.1rem',
            cursor: 'pointer',
            backdropFilter: 'blur(10px)'
          }}
        >
          Go Home
        </button>
        
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: '15px 30px',
            backgroundColor: 'transparent',
            color: 'white',
            border: '2px solid rgba(255, 255, 255, 0.5)',
            borderRadius: '50px',
            fontSize: '1.1rem',
            cursor: 'pointer'
          }}
        >
          Go Back
        </button>
      </div>
    </div>
  );
};

export default NotFoundPage;